import React from 'react';
import { ArrowRight, TrendingDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function PriceMoatBlock() {
  return <section id="fees" className="py-20 md:py-32 px-6 bg-white relative overflow-hidden" data-id="element-288">
      {/* Subtle background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-sand/20 rounded-l-[100px] -z-10" data-id="element-289"></div>

      {/* Playful blobs */}
      <div className="absolute top-40 -left-20 w-72 h-72 bg-coral/5 rounded-full blur-3xl -z-10" data-id="element-290"></div>
      <div className="absolute bottom-20 right-10 w-64 h-64 bg-teal/5 rounded-full blur-3xl -z-10" data-id="element-291"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-292">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-293">
          <div className="inline-flex items-center gap-2 bg-coral/10 text-coral px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-294">
            <TrendingDown size={18} data-id="element-295" />
            Wyndham Vale's Best Value
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-navy mb-6 tracking-tight" data-id="element-296">
            You'll save $26-58 a day at Funtastic Kidz vs other Wyndham Vale
            centres.
          </h2>
          <p className="text-lg md:text-xl text-navy/70 max-w-3xl mx-auto font-medium" data-id="element-297">
            The figures are public — published on CareforKids and the centres'
            own websites. We charge less because we're family-run, not a
            national chain.{' '}
            <strong className="text-navy font-bold" data-id="element-298">
              Less brand budget, more value to your family.
            </strong>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-white rounded-[24px] border border-sand overflow-hidden shadow-card mb-12" data-id="element-299">
          <div className="overflow-x-auto hide-scrollbar" data-id="element-300">
            <table className="w-full text-left border-collapse min-w-[700px]" data-id="element-301">
              <thead data-id="element-302">
                <tr className="bg-sand/30 border-b border-sand" data-id="element-303">
                  <th className="py-6 px-8 font-bold text-navy text-lg" data-id="element-304">
                    Centre
                  </th>
                  <th className="py-6 px-8 font-bold text-navy text-lg" data-id="element-305">
                    Daily fee
                  </th>
                  <th className="py-6 px-8 font-bold text-navy text-lg" data-id="element-306">
                    What you pay per week (5 days)
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-307">
                {/* Highlighted Funtastic Row */}
                <tr className="bg-teal text-white relative shadow-lg transform scale-[1.02] z-10 rounded-lg" data-id="element-308">
                  <td className="py-8 px-8 font-extrabold text-xl flex items-center gap-3 rounded-l-lg" data-id="element-309">
                    Funtastic Kidz
                    <span className="bg-yellow text-navy text-xs px-3 py-1.5 rounded-full font-bold uppercase tracking-wider" data-id="element-310">
                      Best Value
                    </span>
                  </td>
                  <td className="py-8 px-8 font-extrabold text-3xl" data-id="element-311">$118</td>
                  <td className="py-8 px-8 font-extrabold text-3xl rounded-r-lg" data-id="element-312">
                    $590
                  </td>
                </tr>
                {/* Competitor Rows */}
                <tr className="border-b border-sand/50 hover:bg-sand/10 transition-colors" data-id="element-313">
                  <td className="py-6 px-8 text-navy font-semibold text-lg" data-id="element-314">
                    Wyndham Vale suburb average
                  </td>
                  <td className="py-6 px-8 text-red font-bold text-xl" data-id="element-315">$144</td>
                  <td className="py-6 px-8 text-red font-bold text-xl" data-id="element-316">$720</td>
                </tr>
                <tr className="border-b border-sand/50 hover:bg-sand/10 transition-colors" data-id="element-317">
                  <td className="py-6 px-8 text-navy font-semibold text-lg" data-id="element-318">
                    Busy Bees Wyndham Vale
                  </td>
                  <td className="py-6 px-8 text-red font-bold text-xl" data-id="element-319">
                    $176.70
                  </td>
                  <td className="py-6 px-8 text-red font-bold text-xl" data-id="element-320">
                    $883.50
                  </td>
                </tr>
                <tr className="hover:bg-sand/10 transition-colors" data-id="element-321">
                  <td className="py-6 px-8 text-navy font-semibold text-lg" data-id="element-322">
                    Goodstart Tarneit
                  </td>
                  <td className="py-6 px-8 text-red font-bold text-xl" data-id="element-323">
                    $158-$165
                  </td>
                  <td className="py-6 px-8 text-red font-bold text-xl" data-id="element-324">
                    $790-$825
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="bg-sand/20 py-4 px-8 text-xs font-medium text-navy/50 text-right border-t border-sand" data-id="element-325">
            Rates sourced April 2026. Confirm current rates before booking.
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-326">
          <a href="#ccs-calculator" className="w-full sm:w-auto bg-blue text-white px-10 py-5 rounded-btn font-bold text-lg hover:bg-blue-deep transition-colors shadow-md hover:shadow-lg hover:-translate-y-1 transform duration-200 text-center flex items-center justify-center gap-3" data-id="element-327">
            Calculate your CCS-net price
            <ArrowRight size={20} data-id="element-328" />
          </a>
          <a href="#tours" className="w-full sm:w-auto text-navy font-bold text-lg hover:text-coral transition-colors text-center py-4 px-8" data-id="element-329">
            Book a tour
          </a>
        </motion.div>
      </div>
    </section>;
}